import { useState } from 'react'
import { signOut } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

import {
  Button,
  Divider,
  Icon,
  Popover,
  SuperEllipse,
  Typography
} from '@themenu/design-system'

import { Store } from 'store'
import { useSessionStore } from 'store/session'
import { getNameInitials } from 'utils/helpers/getNameInitials'

export const UserMenu = () => {
  const { user } = useSessionStore()
  const router = useRouter()
  const { resetAllStores } = Store()

  const [isOpen, setIsOpen] = useState(false)

  const handleMyProfileClick = () => {
    router.push('/profile')
    setIsOpen(false)
  }

  const handleLogOff = () => {
    resetAllStores()
    signOut()

    if (window.zE) {
      window.zE('messenger', 'close')
      window.zE('messenger', 'hide')
    }
  }

  return (
    <Popover
      trigger={
        <Button
          variant="text"
          size={24}
          className="flex justify-between gap-8 px-12 border-none max-w-[160px] md:max-w-[320px] after:content-none"
          aria-label="Abrir menu do usuário"
        >
          <SuperEllipse
            size={32}
            image={user?.avatar || ''}
            text={getNameInitials(user?.name || '')}
            colorSet="success"
            className="flex-shrink-0"
          />
          <Typography variant="callout" className="block truncate">
            {user.name}
          </Typography>
          <Icon
            size={16}
            name={'chevron-down'}
            className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        </Button>
      }
      isOpen={isOpen}
      onToggle={setIsOpen}
      placement="bottom right"
    >
      <div className="flex flex-wrap flex-col gap-8 p-12 w-[264px] min-w-0">
        <Typography variant="caption">Minha conta</Typography>
        <Button
          size={40}
          startIcon={'user-gear'}
          variant="text"
          className="max-w-full"
          onClick={handleMyProfileClick}
        >
          Meu perfil
        </Button>
        <Divider my={8} />
        <Button
          size={40}
          variant="critical"
          className="max-w-full"
          onClick={handleLogOff}
        >
          Desconectar
        </Button>
        <div>
          <Link href="#">
            <Typography variant="caption">Privacidade</Typography>
          </Link>
          <span>・</span>
          <Link href="#">
            <Typography variant="caption">Termos de uso</Typography>
          </Link>
          <Typography variant="caption" className="text-content-subdued">
            Swile: Inscrição no PAT <strong>180629004</strong>
          </Typography>
        </div>
      </div>
    </Popover>
  )
}
